import React, { useMemo } from 'react';
import PropTypes, { node } from 'prop-types';
import withLayoutProps from '../../../hocs/withLayoutProps';
import { useAdsProvider } from '../../../contexts/index';
import { useAdsBrands } from './useAdsBrands';
import { SectionBanner } from './AdsBrand.styles';
import AdsBrandDesktop from './AdsBrandDesktop';
import AdsBrandsMobile from './AdsBrandsMobile';
var AdsBrand = function AdsBrand(_ref) {
  var children = _ref.children,
    data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _staticProps$marginTo = staticProps.marginTop,
    marginTop = _staticProps$marginTo === void 0 ? '0px' : _staticProps$marginTo,
    _staticProps$marginBo = staticProps.marginBottom,
    marginBottom = _staticProps$marginBo === void 0 ? '0px' : _staticProps$marginBo;
  var memoizedStaticProps = useMemo(function () {
    return staticProps;
  }, [staticProps]);
  var _useAdsBrands = useAdsBrands({
      brands: memoizedStaticProps.brands,
      data: data,
      "static": memoizedStaticProps,
      structure: structure
    }),
    adsPath = _useAdsBrands.adsPath,
    loading = _useAdsBrands.loading,
    brand = _useAdsBrands.brand,
    handleBrandClick = _useAdsBrands.handleBrandClick,
    handleBrandImpression = _useAdsBrands.handleBrandImpression,
    handleProductClick = _useAdsBrands.handleProductClick,
    handleProductView = _useAdsBrands.handleProductView,
    isVideo = _useAdsBrands.isVideo;
  var _useAdsProvider = useAdsProvider(),
    isBannerLoading = _useAdsProvider.isLoading;
  var shouldRenderComponent = useMemo(function () {
    return !loading && !isBannerLoading;
  }, [loading, isBannerLoading]);
  var shouldShowBanner = useMemo(function () {
    return !brand;
  }, [brand]);
  return shouldRenderComponent ? React.createElement(React.Fragment, null, shouldShowBanner ? React.createElement(SectionBanner, null, children) : staticProps.channel === 'MSITE' ? React.createElement(AdsBrandsMobile, {
    marginTop: marginTop,
    marginBottom: marginBottom,
    adsPath: adsPath,
    brand: brand,
    handleBrandClick: handleBrandClick,
    handleBrandImpression: handleBrandImpression,
    handleProductClick: handleProductClick,
    handleProductView: handleProductView,
    isVideo: isVideo
  }) : React.createElement(AdsBrandDesktop, {
    marginTop: marginTop,
    adsPath: adsPath,
    brand: brand,
    handleBrandClick: handleBrandClick,
    handleBrandImpression: handleBrandImpression,
    handleProductClick: handleProductClick,
    handleProductView: handleProductView,
    isVideo: isVideo
  })) : null;
};
AdsBrand.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
process.env.NODE_ENV !== "production" ? AdsBrand.propTypes = {
  children: node.isRequired,
  data: PropTypes.shape({}),
  "static": PropTypes.oneOfType([PropTypes.shape({
    isBannerCarousel: PropTypes.bool,
    position: PropTypes.string,
    slot: PropTypes.string
  }), PropTypes.shape({
    campaignId: PropTypes.string,
    customerId: PropTypes.string,
    hasPlaceholder: PropTypes.bool,
    height: PropTypes.string,
    imageUrl: PropTypes.string,
    index: PropTypes.number,
    position: PropTypes.string,
    redirectUrl: PropTypes.string,
    slot: PropTypes.string,
    trackId: PropTypes.string,
    width: PropTypes.string
  })]),
  structure: PropTypes.shape({
    cookies: PropTypes.shape({
      accountData: PropTypes.shape({
        customerId: PropTypes.string
      })
    })
  })
} : void 0;
AdsBrand.ssr = true;
export default withLayoutProps(AdsBrand);